export default "__VITE_ASSET__Boh5I5mm__";